import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../config/app-paths';

export const LoginAuthGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkSession$().pipe(
    map((hasSession: boolean) => {
      if (hasSession) {
        return router.createUrlTree([APP_PATHS.home]);
      }
      return true;
    }),
  );
};
